import React from 'react';
import { Link, useLocation } from 'react-router-dom';

type TabKey = 'resumo' | 'manutencoes' | 'custos' | 'documentos';

export function getFrotaTab(pathname: string, hash = ''): TabKey {
  if (pathname.includes('/manutencoes')) return 'manutencoes';
  if (pathname.includes('/custos')) return 'custos';
  if (pathname.includes('/documentos') || hash === '#documentos') return 'documentos';
  return 'resumo';
}

const FrotaVehicleTabs: React.FC<{ id: string }> = ({ id }) => {
  const location = useLocation();
  const active = getFrotaTab(location.pathname, location.hash);
  const tabs: { key: TabKey; label: string; to: string }[] = [
    { key: 'resumo', label: 'Resumo', to: `/patrimonio/frota/${id}` },
    { key: 'manutencoes', label: 'Manutenções', to: `/patrimonio/frota/${id}/manutencoes` },
    { key: 'custos', label: 'Custos', to: `/patrimonio/frota/${id}/custos` },
    { key: 'documentos', label: 'Documentos', to: `/patrimonio/frota/${id}/documentos` },
  ];

  return (
    <div className="flex gap-1 border-b border-gray-200">
      {tabs.map(t => (
        <Link
          key={t.key}
          to={t.to}
          className={`px-4 py-2.5 text-sm font-medium border-b-2 -mb-px ${
            active === t.key
              ? 'border-primary-600 text-primary-700'
              : 'border-transparent text-gray-500 hover:text-gray-800'
          }`}
        >
          {t.label}
        </Link>
      ))}
    </div>
  );
};

export default FrotaVehicleTabs;
